import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IMonthlyActiveUserCount } from '@/shared/model/monthly-active-user-count.model';

const baseApiUrl = 'api/monthly-active-user-counts';
const baseSearchApiUrl = 'api/_search/monthly-active-user-counts?query=';

export default class MonthlyActiveUserCountService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IMonthlyActiveUserCount> {
    return new Promise<IMonthlyActiveUserCount>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IMonthlyActiveUserCount): Promise<IMonthlyActiveUserCount> {
    return new Promise<IMonthlyActiveUserCount>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IMonthlyActiveUserCount): Promise<IMonthlyActiveUserCount> {
    return new Promise<IMonthlyActiveUserCount>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
